import {
	Configure,
	InstantSearch,
	type InstantSearchServerState,
	InstantSearchSSRProvider,
} from "react-instantsearch";
import { cn } from "tailwind-variants";
import type { AlgoliaSearchSettings } from "#/app/features/search/types";
import { getSearchClient } from "#/app/features/search/utils/get-search-client.ts";
import Hits from "./components/Hits.tsx";
import Pagination from "./components/Pagination.tsx";
import RefinementList from "./components/RefinementList.tsx";
import SearchBox from "./components/SearchBox.tsx";

export function SearchExperience({
	settings: searchSettings,
	query,
	className,
	serverState,
	showContentTagFilter = true,
	contained = true,
}: {
	settings: AlgoliaSearchSettings;
	query: string;
	className?: string;
	serverState?: InstantSearchServerState;
	showContentTagFilter?: boolean;
	contained?: boolean;
}) {
	const searchClient = getSearchClient(
		searchSettings.applicationId,
		searchSettings.publicApiKey,
	);
	return (
		<div className={cn(contained && "container", "mb-8", className)}>
			<InstantSearchSSRProvider {...serverState}>
				<InstantSearch
					key={`${searchSettings.indexName}:${query}`}
					initialUiState={{ [searchSettings.indexName]: { query } }}
					searchClient={searchClient}
					indexName={searchSettings.indexName}
					insights
				>
					<Configure hitsPerPage={20} attributesToSnippet={["content:30"]} />
					<div className="search-page">
						<div className="search-page-form">
							<SearchBox />
						</div>
						{showContentTagFilter ? <RefinementList attribute="tags" /> : null}
						<div className="search-page-results">
							<Hits />
							<div className="me-xl-8 my-8">
								<Pagination />
							</div>
						</div>
					</div>
				</InstantSearch>
			</InstantSearchSSRProvider>
		</div>
	);
}
